const utils = require('../../../lib/utils')

module.exports = {
	model: {
		nrOfElements: -1
	},

	events: {
		open: {
			type: 'click',
			action(event) {
				const self = event.data.component
				const $target = $(event.target).closest('button, a')

				if($target.length > 0) {
					const {
						buttonMode,
						fieldType,
					} = $target.data() || {}

					if(fieldType === 'open') {
						return
					} else if(buttonMode === 'empty') {
						self.empty()
					} else if(buttonMode === 'reset'){
						self.reset()
					} else {
						const presetFilterParams = {}
						if(buttonMode === 'selected'){
							presetFilterParams.limitByCheckboxSelection = 1
						}
						self.open(undefined, undefined, { treeFilters: {
							presetFilterParams
						}})
					}
				}

				event.preventDefault()
				event.stopImmediatePropagation()
			}
		}
	},

	methods: {
		prepare(){
			if(this.model.nrOfElements < 0){
				this.model.nrOfElements = utils.collectionSize(this.model.dataJSON)
				this.model.originalDataJSON = utils.simpleCopy(this.model.dataJSON)
			}
		},

		open(ckEditorButton, overrideDirtyAssignedRoutes, additionalResourceRegisters){
			let assignedRoutes
			if(overrideDirtyAssignedRoutes !== undefined){
				assignedRoutes = overrideDirtyAssignedRoutes
			} else if(utils.collectionSize(this.model.dirtyAssignedRoutes) > 0){
				assignedRoutes = this.model.dirtyAssignedRoutes
			} else if(this.model.dataJSON){
				assignedRoutes = this.model.dataJSON
			}
			this.model.ckEditorButton = ckEditorButton

			this.performAndStoreAction(
				'routePickerModal',
				this.prepareAction(
					'showRoutePicker',
					undefined,
					{
						assignedRoutes,
						selectionConfig: {
							multiSelect: (this.model.config || {}).multiSelect || false,
							selectCascade: (this.model.config || {}).selectCascade || '',
							usePrimaryKeyAsObjectKeyDataFormat: (this.model.config || {}).usePrimaryKeyAsObjectKeyDataFormat || false
						},
						...(additionalResourceRegisters || {})
					}, {
						source: {
							load: {
								componentData: {
									config: {
										overruleCKEditor: !!ckEditorButton
									}
								}
							}
						}
					}
				),
				true
			)
		},

		empty(){
			this.model.dirtyAssignedRoutes = {}

			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode,
				value: this.model.dirtyAssignedRoutes
			})
			this.model.dataJSON = utils.simpleCopy(this.model.dirtyAssignedRoutes)
			this.model.nrOfElements = utils.collectionSize(this.model.dataJSON)
			this.refresh(false)
		},

		reset(){
			this.model.dirtyAssignedRoutes = {}
			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode
			})
			this.model.dataJSON = utils.simpleCopy(this.model.originalDataJSON)
			this.model.nrOfElements = utils.collectionSize(this.model.dataJSON)
			this.refresh()
		}
	},

	hooks: {
		async onDecision($element, options){
			// TODO: CLEANUP => NEW FORMAT
			// decisionComponent: <selectRouteTrees>,
			// decisionType: 'submit',
			// decisionOptions: <decisionOptions>,
			// data: <listOfSelectedEntities> [{<properties>, ...}, ...]
			options = options || {}

			switch(options.decisionType){
				case 'decisionComponent':
					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						await options.decisionComponent.hide()
					}

					if(this.model.ckEditorButton){
						const rI = Object.keys(this.model.dirtyAssignedRoutes || {})[0] || 0
						const routeID = ((this.model.dirtyAssignedRoutes || {})[rI] || {}).routeID
						if(routeID) this.model.ckEditorButton.setValue(routeID);
					} else {
						this.triggerClosest('onChildChanged', {
							fieldCode: this.model.fieldCode,
							value: this.model.dirtyAssignedRoutes
						})
						this.model.dataJSON = utils.simpleCopy(this.model.dirtyAssignedRoutes)
						this.model.nrOfElements = utils.collectionSize(this.model.dataJSON)
						await this.refresh()
					}
					break

				case 'submit':
					this.model.dirtyAssignedRoutes = {}
					let routeCounter = 0
					const fieldConfig = this.model.config || {}
					utils.forEach(options.data || {}, route => {
						route = route || {}
						if(route.routeID){
							if(route.unselect){
								if(fieldConfig.usePrimaryKeyAsObjectKeyDataFormat){
									delete this.model.dirtyAssignedRoutes[route.routeID]
								} else {
									for(const routeIndex in this.model.dirtyAssignedRoutes){
										if((this.model.dirtyAssignedRoutes[routeIndex] || {}).routeID === route.routeID){
											delete this.model.dirtyAssignedRoutes[routeIndex]
											break
										}
									}
								}
							} else {
								if(fieldConfig.usePrimaryKeyAsObjectKeyDataFormat){
									this.model.dirtyAssignedRoutes[route.routeID] = {
										routeID: route.routeID
									}
								} else {
									this.model.dirtyAssignedRoutes[routeCounter++] = {
										routeID: route.routeID
									}
								}
							}
						}
					})

					// cleanup indexes if necessary
					if(!fieldConfig.usePrimaryKeyAsObjectKeyDataFormat){
						routeCounter = 0
						const dirtyAssignedRoutes = {}
						for(const routeIndex in this.model.dirtyAssignedRoutes){
							dirtyAssignedRoutes[routeCounter++] = this.model.dirtyAssignedRoutes[routeIndex]
						}
						this.model.dirtyAssignedRoutes = dirtyAssignedRoutes
					}

					break

				case 'cancel':
				default:
					if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
						await options.decisionComponent.hide()
					}
					break
			}
		}
	}
}